import React from "react";
import { motion } from "framer-motion";
import { useTr } from "@/autoTranslate";
import { useSiteContent } from "@/siteContent";

const chapVariant = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.06, duration: 0.9, ease: [0.16, 1, 0.3, 1] },
  }),
};

export default function Manifesto() {
  const tr = useTr();
  const site = useSiteContent();
  const chapters = site.getList("manifesto.list");
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="relative px-6 md:px-10 py-8 md:py-12"
    >

      <div className="mt-12 md:mt-24 grid grid-cols-1 md:grid-cols-12 gap-x-6 gap-y-16">
        <div className="md:col-span-4">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-15%" }}
            transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
            className="display-serif italic text-5xl md:text-7xl leading-[0.95]"
          >
            {tr(site.get("manifesto.title"))}
          </motion.h2>
          <p className="mt-6 md:mt-8 font-mono-label text-xs uppercase tracking-widest opacity-70 max-w-xs">
            {tr(site.get("manifesto.intro"))}
          </p>
        </div>

        <div className="md:col-span-8 md:pl-12 md:border-l md:border-[color:var(--hair)]">
          {chapters.map((c, i) => (
            <motion.div
              key={i}
              variants={chapVariant}
              custom={i}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-15%" }}
              className="py-8 md:py-10 border-b border-[color:var(--hair)] last:border-0 grid grid-cols-12 gap-6 md:gap-10"
              data-testid={`manifesto-chapter-${i}`}
            >
              <div className="col-span-2 md:col-span-2">
                <span className="chapter-num text-3xl md:text-5xl">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <div className="col-span-10 md:col-span-10">
                <h3 className="display-sans text-2xl md:text-4xl leading-tight">
                  {tr(c.title)}
                </h3>
                <p className="mt-3 md:mt-4 text-base md:text-lg leading-relaxed max-w-2xl text-[color:var(--ink-soft)]">
                  {tr(c.body)}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
